import { IntegrationLogoBox } from "@/integrations";

export default function IntegrationCellTitle(props: {
  integrationId: string;
  connectionLabel?: string;
  size?: React.ComponentProps<typeof IntegrationLogoBox>["size"];
}) {
  return (
    <div className="flex items-center space-x-2 whitespace-nowrap">
      <IntegrationLogoBox id={props.integrationId} size="xs" />
      <div>{props.connectionLabel || props.integrationId}</div>
    </div>
  );
}
